<template>
  <div id="contenedor-main-usuario">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'MainUsuario',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
